import { Button } from '@replai-platform/ui-components';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { CellData, GeneratedColumn, RequiredGeneratorParams } from '../../common';

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export type ReportFavoriteAccessorType = {
  onReportFavoriteClick?: (
    setButtonLoading: React.Dispatch<React.SetStateAction<boolean>>,
    isFavoriteStarFilled: boolean,
    setIsFavoriteStarFilled: React.Dispatch<React.SetStateAction<boolean>>
  ) => void;
  favorite?: boolean;
};

const ReportFavoriteCellDecorator: React.FC<{
  cellData: ReportFavoriteAccessorType;
}> = ({ cellData }) => {
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);
  const [isFavoriteStarFilled, setIsFavoriteStarFilled] = useState<boolean>(cellData?.favorite ?? false);

  useEffect(() => {
    setIsFavoriteStarFilled(cellData?.favorite ?? false);
  }, [cellData?.favorite]);

  if (!cellData) {
    return null;
  }

  return (
    <ButtonContainer>
      <Button
        trailingIcon={{ name: buttonLoading ? 'LoadingCircle' : isFavoriteStarFilled ? 'Star100' : 'Star' }}
        onClick={() => {
          cellData?.onReportFavoriteClick?.(setButtonLoading, isFavoriteStarFilled, setIsFavoriteStarFilled);
        }}
        disabled={buttonLoading}
        color="Warning"
        variant="text"
        aria-label={isFavoriteStarFilled ? 'Remove from favorites' : 'Add to favorites'}
        aria-pressed={isFavoriteStarFilled}
      />
    </ButtonContainer>
  );
};

function getReportFavoriteColumn<T extends object = ReportFavoriteAccessorType>({
  columnId,
  accessor,
}: RequiredGeneratorParams<T, ReportFavoriteAccessorType>): GeneratedColumn<T> {
  return {
    id: columnId,
    accessor,
    Cell: (data: CellData<T, ReportFavoriteAccessorType>) => (
      <ReportFavoriteCellDecorator cellData={data?.cell?.value} />
    ),
  };
}

export default getReportFavoriteColumn;
